import type { ICustomControlSupervisionReadProps } from '../../interfaces/';
import { SupervisorsAssessmentBiometrics } from '../../../../../../common/enums/supervisorsAssessmentBiometrics';
import { translateKey } from '../../../../../translate';
import { FormParagraph } from '../../../../elements/common';
import { FormLabel } from '../../../../elements/forms/FormLabel';
import { HorizontalFormGroupRead } from '../../../../elements/forms/horizontalFormGroupRead/HorizontalFormGroupRead';
import { InputContainer } from '../../../../elements/forms/InputContainer';

export function TfoV1SupervisionBiometricsSummary(props: ICustomControlSupervisionReadProps) {
    return (
        <>
            <HorizontalFormGroupRead>
                <FormLabel>Beoordeling foto's</FormLabel>
                <InputContainer>
                    <FormParagraph>
                        {props.supervision.assessmentBiometrics
                            ? translateKey(
                                  `supervisorsAssessmentBiometricsEnum.${props.supervision.assessmentBiometrics}`
                              )
                            : '-'}
                    </FormParagraph>
                </InputContainer>
            </HorizontalFormGroupRead>

            {props.supervision.assessmentBiometrics !== SupervisorsAssessmentBiometrics.good && (
                <HorizontalFormGroupRead>
                    <FormLabel>Toelichting kwaliteitscontrole</FormLabel>
                    <InputContainer>
                        {props.supervision.customControlData?.toelichting_kwaliteitscontrole?.niet_gedruppeld && (
                            <FormParagraph>Niet gedruppeld</FormParagraph>
                        )}
                        {props.supervision.customControlData?.toelichting_kwaliteitscontrole?.cataract && (
                            <FormParagraph>Cataract</FormParagraph>
                        )}
                        {props.supervision.customControlData?.toelichting_kwaliteitscontrole?.anders_namelijk && (
                            <FormParagraph>
                                {props.supervision.customControlData?.toelichting_kwaliteitscontrole?.anders_namelijk}
                            </FormParagraph>
                        )}
                    </InputContainer>
                </HorizontalFormGroupRead>
            )}
        </>
    );
}
